export function getBlockData<T>(
  _code: string,
  listBlock: BlockDataTypes<T>[],
): T | undefined {
  const findIndex = listBlock.findIndex((item) => item.code === _code);
  if (findIndex < 0) {
    return undefined;
  }
  return listBlock[findIndex].blocks;
}

export function getBannerData(
  _code: string,
  listBlock: BannersDataTypes[],
): BannerData | undefined {
  if (!listBlock) return undefined;
  const findIndex = listBlock.findIndex((item) => item.type === _code);
  if (findIndex < 0) {
    return undefined;
  }
  return listBlock[findIndex].data;
}
